<template>
    <GeneralSection
        v-if="section"
        :id="`section-${section._id}`"
        :section="section"
        :section-style="heroStyle"
    />
</template>

<script>
import GeneralSection from "@/scripts/view/portfolio/sections/GeneralSection.vue";
import {updateSectionLevelColorCssInHead} from "@/scripts/common/TextStyleRenderHelper.js";

export default {
    name: "PortfolioHeroSection",
    components: {
        GeneralSection,
    },
    props: {
        section: {
            type: Object,
            default: null,
        }
    },
    beforeMount() {
        if(!this.$route.query.templatePreview) {
            updateSectionLevelColorCssInHead(this.section)
        }
    },
    computed: {
        sectionHeight() {
            const height = this.section?.styleSettings?.sectionHeight;
            if (height === null || height === undefined || height === "") return null;
            const numeric = Number(height);
            return Number.isFinite(numeric) ? Math.round(numeric) : null;
        },
        heroStyle() {
            const height = this.sectionHeight;
            if (!height) return null;
            const verticalAlign = this.section?.styleSettings?.boxAlign?.split("-")?.[1] || "middle";
            const alignMap = {
                top: "flex-start",
                middle: "center",
                bottom: "flex-end",
            };
            return {
                '--sectionHeight': `${height}px`,
                '--heroContentAlign': alignMap[verticalAlign] || "center",
            };
        },
    }
};
</script>
